import { createSelector } from 'reselect';
import { getExternalReferenceEntitiesProperties } from './properties/index.tsx';

export const getAllExternalReferenceEntities = createSelector(
	getExternalReferenceEntitiesProperties,
	(externalReferenceEntities) => externalReferenceEntities,
);
